export default __webpack_public_path__ + "images/5414c7c5bdc8cc965c923a10995fbf8f-august_banner_desktop.webp";